// src/components/AndroidAppBanner.jsx
// Android端末で表示するアプリDL誘導バナー【2026-07-21】
// - UAに "Android" を含むときだけ表示（iOS/PCには出ない）
// - 「あとで」で localStorage に記憶し、以後表示しない
// - /app-download 表示中は出さない
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from './Icon';

const IS_ANDROID = /Android/i.test(navigator.userAgent);
const DISMISS_KEY = 'androidBannerDismissed';

export default function AndroidAppBanner() {
  const location = useLocation();
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) === '1'; } catch { return false; }
  });

  if (!IS_ANDROID || dismissed || location.pathname === '/app-download') return null;

  const dismiss = () => {
    setDismissed(true);
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch { /* private mode等は無視 */ }
  };

  return (
    <div className="page-container">
      <div className="android-banner">
        <span className="android-banner-icon"><Icon name="smartphone" size={28} /></span>
        <div className="android-banner-text">
          <strong>出席アプリをここからダウンロード</strong>
          <p>Android用アプリでより快適に出席登録できます。</p>
        </div>
        <div className="android-banner-actions">
          <Link to="/app-download" className="btn-primary android-banner-link">ダウンロード</Link>
          <button className="btn-secondary" onClick={dismiss}>あとで</button>
        </div>
      </div>
    </div>
  );
}
